import React from 'react'
import {
  heading,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import lock from 'assets/chat/illustrations/lock.png'

import { styles } from './styles'

const NoAccess = ({ title, copy, children, className }) => {
  return (
    <div css={styles.container} className={className}>
      <div css={styles.content}>
        <div css={styles.imgWrapper}>
          <img src={lock} alt="lock" />
        </div>
        <h1 css={heading.styles.h2}>{title}</h1>
        <p css={[text.styles.textNormal, text.styles.textDark]}>{copy}</p>
        {children}
      </div>
    </div>
  )
}

export default NoAccess
